import {AxiosInstance} from 'axios';
import {axiosFactory} from '../../../../client';
import * as ROUTES from './routes';
import {
  BulkDownloadCoordinatorResultReleaseResponse,
  CoordinatorResultReleaseResponse,
} from '../models';
import {SearchParamSchema} from '../../../../../models/SearchParamSchema';
import {
  CandidatePsleResultReleaseSchema,
  CandidateResultReleaseSchema
} from '../../../../../models/@candidate/CandidateResultReleaseSchema';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api/`;
const timeout = 5000;

export const coordinatorResultReleaseClient = axiosFactory(baseURL, timeout);

export const coordinatorResultReleaseTestClient = (coordinatorResultReleaseClient as unknown) as AxiosInstance;

/** to get result release according to search param
 */
export const postCoordinatorSearchResultRelease = (
    csrfToken: string,
    searchTerms: SearchParamSchema
) =>
    coordinatorResultReleaseClient.post<CoordinatorResultReleaseResponse>(
        csrfToken,
        `${ROUTES.POST_COORDINATOR_RESULT_RELEASE_SEARCH_PARAM}?size=${searchTerms.size}&page=${searchTerms.page}`,
        {
          q: searchTerms.keywords,
          examCode: searchTerms.examCode,
        }
    );

/** to get individual result release by index no
 * */
export const getCoordinatorIndividualResultReleaseByIndexNo = (indexNo: string) =>
    coordinatorResultReleaseClient.get<CandidateResultReleaseSchema | CandidatePsleResultReleaseSchema>(
        `${ROUTES.GET_COORDINATOR_CANDIDATE_RELEASE_BY_INDEX_NO}/${indexNo}`
    );

/** to post bulk download data
 * */
export const postCoordinatorBulkUploadData = (csrfToken: string, data: string[]) =>
    coordinatorResultReleaseClient.post<BulkDownloadCoordinatorResultReleaseResponse>(
        csrfToken,
        `${ROUTES.BULK_DOWNLOAD_COORDINATOR_RESULT_RELEASE}`,
        data
    );
